import {
  base_app_title,
  exocad_title,
  face_app_title,
  freedom_i_horizontal,
  icon_app_exe_cam,
  icon_app_exe_exocad,
  icon_app_exocad,
  icon_app_face,
  icon_app_match,
  icon_app_milling,
  icon_app_scan,
  icon_app_scan_i,
  icon_app_smile,
  icon_nav_account,
  icon_nav_home,
  icon_nav_invoice,
  icon_nav_on_account,
  icon_nav_on_home,
  icon_nav_on_invoice,
  icon_nav_on_partner,
  icon_nav_on_patient,
  icon_nav_on_project,
  icon_nav_on_quickstart,
  icon_nav_on_store,
  icon_nav_on_support,
  icon_nav_partner,
  icon_nav_patient,
  icon_nav_project,
  icon_nav_quickstart,
  icon_nav_store,
  icon_nav_support,
  icon_partner_send,
  icon_project_accept,
  icon_project_chat,
  icon_project_invite,
  icon_project_manager,
  icon_project_update,
  match_app_title,
  motion_app_title,
  product_craftx_5x,
  scan_app_i_title,
  scan_app_title,
  smile_app_title,
} from 'components/base/images';
import { T } from 'components/common/text';
import React from 'react';
import { color } from 'styles/utils';
import * as THREE from 'three';

export const exocadVersion = 3;

export const userCustomOption = {
  indication: 'CI',
  material: 'CM',
  unknown: 'UNKNOWN',
};
export const brand = {
  logo: {
    index: 'logo',
    text: 'DOF Bridge',
  },
};

export const setting = {
  language: {
    kr: {
      id: 1,
      label: 'Korean',
      index: 'KR',
    },
    en: {
      id: 2,
      label: 'English',
      index: 'EN',
    },
    jp: {
      id: 3,
      code: 'Japanese',
      text: 'JP',
    },
  },
};

export const pageUrl = {
  index: '/',
  home: '/home',
  auth: {
    index: '/auth',
    codeRegistration: '/auth/code-registration',
    signIn: '/auth/login',
    signUp: '/auth/join',
    signOut: '/auth/logout',
    passwordInquiry: '/auth/password/inquiry',
    passwordReset: '/auth/password/reset',
  },
  error: {
    index: '/error',
    server: '/error/500',
    notFound: '/error/404',
  },
  dashboard: {
    index: '/dashboard',
  },
  quickstart: {
    index: '/quickstart',
  },
  notifications: {
    index: '/notifications',
  },
  project: {
    index: '/project',
    list: '/project/list',
    detail: '/project/detail/:pcode',
    fullscreen: '/project/fullscreen',
    create: { new: '/project/create/new', patient: '/project/create/patient/:ptcode' },
    edit: '/project/edit/:pcode',
    copy: '/project/copy/:pcode',
    creating: '/project/creating/:pcode',
    creatWaiting: '/project/creating',
  },
  user: {
    index: '/mypage',
  },
  mypage: {
    index: '/mypage',
    information: '/mypage/infomation',
    partners: '/mypage/partners',
    product: '/mypage/product',
    option: '/mypage/option',
    history: '/mypage/history',
  },
  store: {
    index: '/store',
    data: '/store/data',
    app: '/store/app',
    warranty: '/store/warranty',
  },
  invoice: {
    index: '/invoice',
  },
  notifications: {
    index: '/notifications',
  },
  support: {
    index: '/support',
  },
  partner: {
    index: '/partner',
    list: '/partner/list',
  },
  account: {
    index: '/account',
  },
  payment: {
    index: '/payment',
    success: '/payment/payletter/return/success',
    cancel: '/payment/payletter/return/cancel',
    cashreceipt: '/payment/payletter/return/cashreceipt',
    virtualaccount: '/payment/payletter/return/virtualaccount',
    paymentTestPopupUrl: '/payment/payletter/return/paymentTestPopupUrl',
  },
  kpi: {
    index: '/kpi',
    list: '/kpi/list',
    add: '/kpi/add',
  },
  dev: {
    hds: '/dev/test/hds',
  },
  patient: {
    index: '/patient',
    list: '/patient/list',
    detail: '/patient/detail/:ptcode',
  },
  Util: {
    index: '/util',
    test: '/util/test',
    imgPopup: '/util/images/:pcode/:imageIdx',
  },
  recording: {
    index: '/recording/:pcode',
  },
};

export const navigation_lab = [
  {
    path: pageUrl.dashboard.index,
    text: 'Home',
    icon: icon_nav_home,
    onIcon: icon_nav_on_home,
    name: 'home',
    code: 'NAV_MENU_HOME',
  },
  {
    path: pageUrl.project.index,
    text: 'Project',
    icon: icon_nav_project,
    onIcon: icon_nav_on_project,
    name: 'project',
    code: 'NAV_MENU_PROJECT',
  },

  {
    path: pageUrl.invoice.index,
    text: 'Invoice',
    icon: icon_nav_invoice,
    onIcon: icon_nav_on_invoice,
    name: 'invoice',
    code: 'NAV_MENU_INVOICE',
  },
  {
    path: pageUrl.account.index,
    text: 'Account',
    icon: icon_nav_account,
    onIcon: icon_nav_on_account,
    name: 'account',
    code: 'NAV_MENU_ACCOUNT',
  },
  {
    path: pageUrl.partner.index,
    text: 'Partner',
    icon: icon_nav_partner,
    onIcon: icon_nav_on_partner,
    name: 'partner',
    code: 'NAV_MENU_PARTNER',
  },
];

export const navigation_clinic = [
  {
    path: pageUrl.quickstart.index,
    text: 'QuickStart',
    icon: icon_nav_quickstart,
    onIcon: icon_nav_on_quickstart,
    name: 'quick',
    code: 'NAV_MENU_QUICKSTART',
  },
  {
    path: pageUrl.project.index,
    text: 'Project',
    icon: icon_nav_project,
    onIcon: icon_nav_on_project,
    name: 'project',
    code: 'NAV_MENU_PROJECT',
  },
  {
    path: pageUrl.patient.index,
    text: 'Patient',
    icon: icon_nav_patient,
    onIcon: icon_nav_on_patient,
    name: 'patient',
    code: 'NAV_MENU_PATIENT',
  },

  {
    path: pageUrl.account.index,
    text: 'Account',
    icon: icon_nav_account,
    onIcon: icon_nav_on_account,
    name: 'account',
    code: 'NAV_MENU_ACCOUNT',
  },
  {
    path: pageUrl.partner.index,
    text: 'Partner',
    icon: icon_nav_partner,
    onIcon: icon_nav_on_partner,
    name: 'partner',
    code: 'NAV_MENU_PARTNER',
  },
  {
    path: pageUrl.dashboard.index,
    text: 'Home',
    icon: icon_nav_home,
    onIcon: icon_nav_on_home,
    name: 'home',
    code: 'NAV_MENU_HOME',
  },
];

export const navigationSub = [
  {
    idx: 0,
    path: pageUrl.store.index,
    text: 'Store',
    icon: icon_nav_store,
    onIcon: icon_nav_on_store,
    name: 'store',
    code: 'NAV_MENU_STORE',
  },
  {
    idx: 1,
    path: pageUrl.support.index,
    text: 'Support',
    icon: icon_nav_support,
    onIcon: icon_nav_on_support,
    name: 'support',
    code: 'NAV_MENU_SUPPORT',
  },
];

export const baseStageTimeLine = [
  { stage: 0, name: 'New', name: 'New' },
  { stage: 1, name: <T>PROJECT_STATUS_FLAG_PREPARATION</T> },
  { stage: 2, name: <T>PROJECT_STATUS_FLAG_SCAN</T> },
  { stage: 3, name: <T>PROJECT_STATUS_FLAG_CAD</T> },
  { stage: 5, name: <T>PROJECT_STATUS_FLAG_MILLING</T> },
  { stage: 6, name: <T>PROJECT_STATUS_FLAG_POST_PROCESS</T> },
  { stage: 7, name: <T>PROJECT_STATUS_FLAG_COMPLETED</T> },
];

export const projectProcessFlagList = [
  {
    id: -1,
    index: 'pending',
    name: 'Pending',
    color: color.stage_pending,
    code: 'PROCESS_PENDING',
  },
  {
    id: 0,
    index: 'new',
    name: 'New',
    color: color.stage_new,
    code: 'PROCESS_NEW',
  },
  {
    id: 1,
    index: 'preparation',
    // name: 'Preparation',
    name: <T>PROJECT_STATUS_FLAG_PREPARATION</T>,
    color: color.stage_preparation,
    code: 'PROCESS_PREPARATION',
  },
  {
    id: 2,
    index: 'scan',
    // name: 'Scan',
    name: <T>PROJECT_STATUS_FLAG_SCAN</T>,
    color: color.stage_scan,
    code: 'PROCESS_SCAN',
  },
  {
    id: 3,
    index: 'cad',
    // name: 'CAD',
    name: <T>PROJECT_STATUS_FLAG_CAD</T>,
    color: color.stage_cad,
    code: 'PROCESS_CAD',
  },
  {
    id: 4,
    index: 'cam',
    name: 'CAM',
    color: color.stage_cam,
    code: 'PROCESS_CAM',
  },
  {
    id: 5,
    index: 'milling',
    // name: 'Milling',
    name: <T>PROJECT_STATUS_FLAG_MILLING</T>,
    color: color.stage_milling,
    code: 'PROCESS_MILLING',
  },
  {
    id: 6,
    index: 'postprocessing',
    // name: 'Post process',
    name: <T>PROJECT_STATUS_FLAG_POST_PROCESS</T>,
    color: color.stage_post,
    code: 'PROCESS_POSTPROCESS',
  },
  {
    id: 7,
    index: 'complete',
    // name: 'Completed',
    name: <T>PROJECT_STATUS_FLAG_COMPLETED</T>,
    color: color.stage_completed,
    code: 'PROCESS_COMPLETE',
  },
  {
    id: -2,
    index: 'urgent',
    name: 'Urgent',
    color: color.stage_urgent,
    code: 'PROCESS_URGENT',
  },
  {
    id: -3,
    index: 'none',
    name: 'None',
    color: color.stage_none,
    code: 'PROCESS_NONE',
  },
];

export const projectProcessFlagListOld = [
  {
    id: 0,
    index: 'new',
    name: 'New',
    color: color.stage_new,
  },
  {
    id: 1,
    index: 'preparation',
    name: 'Preparation',
    color: color.stage_preparation,
  },
  {
    id: 2,
    index: 'scan',
    name: 'Scan',
    color: color.stage_scan,
  },
  {
    id: 3,
    index: 'cad',
    name: 'CAD',
    color: color.stage_cad,
  },

  {
    id: 4,
    index: 'milling',
    name: 'Milling',
    color: color.stage_milling,
  },
  {
    id: 5,
    index: 'postprocessing',
    name: 'Post process',
    color: color.stage_post,
  },
  {
    id: 6,
    index: 'complete',
    name: 'Completed',
    color: color.stage_completed,
  },
];

export const partnerTypeList = [
  { id: 1, text: 'GLOBAL_CLINIC', temp: 'Clinic' },
  { id: 2, text: 'GLOBAL_LABORATORY', temp: 'Laboratory' },
  { id: 3, text: 'GLOBAL_LABORATORY', temp: 'Milling Center' },
];

// socket projectEvent에 따른 분기
export const projectEventType = {
  designerEnter: 'DESIGNER_ENTER',
  designerLeave: 'DESIGNER_LEAVE',
  userEnter: 'USER_ENTER',
  userLeave: 'USER_LEAVE',
  projectUpdate: 'PROJECT_UPDATE',
  applyDesigner: 'APPLY_DESIGNER',
  fileUpload: 'FILE_UPLOAD',
  fileDownload: 'FILE_DOWNLOAD',
  fileDelete: 'FILE_DELETE',
  projectRemakeReq: 'CLIENT_REMAKE_REQ',
  chatImageDelete: 'CHAT_IMAGE_DELETE',
};

export const fileExtensionList = [
  'doc',
  'docx',
  'jpg',
  'mp3',
  'mp4',
  'pdf',
  'png',
  'ppt',
  'pptx',
  'rar',
  'stl',
  'txt',
  'xls',
  'xlsx',
  'zip',
  'obj',
  'ply',
];

// Notification page
export const notificationsEventTypeList = [
  // { eventType: 'PROJECT_CREATE', eventTitle: '프로젝트 생성' },
  // { eventType: 'PROJECT_UPDATE', eventTitle: '프로젝트 업데이트' },
  // { eventType: 'PROJECT_REVIEW', eventTitle: '프로젝트 리뷰 시작' },
  { eventType: 'PROJECT_REVIEW_COMPLETE', eventTitle: '프로젝트 리뷰 완료' },
  // { eventType: 'DESIGNER_WORKING', eventTitle: '디자이너 작업 시작' },
  { eventType: 'DESIGNER_WORK_DONE', eventTitle: '디자이너 작업 완료' },
  { eventType: 'CLIENT_CONFIRM', eventTitle: '클라이언트 컨펌앤페이' },
  { eventType: 'CLIENT_REMAKE_REQ', eventTitle: '클라이언트 리메이크 요청' },
];

export const notificationsModalEventType = {
  client: 'clientByProject',
  designer: 'designerByProject',
};

export const dashboardGridKey = {
  schedule: 'schedule',
  notifications: 'notifications',
  projectStatus: 'projectStatus',
  salesStore: 'salesStore',
  sales: 'sales',
  store: 'store',
  banner: 'banner',
  updatedProject: 'updatedProject',
  milling: 'milling',
  partners: 'partners',
  lectures: 'lectures',
  patient: 'patient',
};

export const invalidFormType = {
  invalidGroupCode: 'INVALID_GROUPCODE',
  invalidEmail: 'INVALID_EMAIL',
  invalidPassword: 'INVALID_PASSWORD',
  invalidEmployee: 'INVALID_EMPLOYEE',
};

export const appList = [
  {
    isStore: true,
    name: 'FaceApp',
    appName: 'FaceApp',
    icon: icon_app_face,

    code: 'APP_FACEAPP',
    class: 'face_app',
    color: '#F08C00',
    buttonColor: '#F08C00',
    titleImg: face_app_title,
    storeIcon: icon_app_face,
    detail: "Scan the patient's face with \nthe SNAP scanner.",
    progressFlag: null, //타임라인 넘버
    tranlationCode: 'APP_DETAIL_FACEAPP',
  },
  {
    isStore: true,
    name: 'ScanApp',
    appName: 'ScanApp',
    icon: icon_app_scan,

    code: 'APP_SCAN_MODEL_SCANNER',
    class: 'model_scanner',
    color: '#AE52FF',
    buttonColor: '#AE52FF',
    storeIcon: icon_app_scan,
    titleImg: scan_app_title,
    detail: 'Connect with the desktop \nscanner to scan stone \nmodel.',
    progressFlag: 2,
    tranlationCode: 'APP_DETAIL_SCAN_MODEL_SCANNER',
  },
  {
    isStore: true,
    name: 'ScanApp i',
    appName: 'ScanAppI',
    icon: icon_app_scan_i,

    code: 'APP_SCAN_IOS',
    class: 'scan_ios',
    color: '#00A4E3',
    buttonColor: '#00A4E3',
    storeIcon: icon_app_scan_i,
    titleImg: scan_app_i_title,
    detail: 'Connect with the FREEDOM i \nscanner to scan oral data.',
    progressFlag: 2,
    tranlationCode: 'APP_DETAIL_SCAN_IOS',
  },
  {
    isStore: true,
    name: 'MatchApp',
    appName: 'MatchApp',
    icon: icon_app_match,

    code: 'APP_MATCHAPP',
    class: 'match_app',
    color: '#E63462',
    buttonColor: '#E63462',
    storeIcon: icon_app_match,
    titleImg: match_app_title,
    detail: 'Match and align different \nscan data.',
    progressFlag: null,
    tranlationCode: 'APP_DETAIL_MATCHAPP',
  },
  {
    isStore: true,
    name: 'SmileApp',
    appName: 'SmileApp',
    icon: icon_app_smile,

    code: 'APP_SMILEAPP',
    class: 'Smail_app',
    color: '#1CABAE',
    buttonColor: '#1CABAE',
    storeIcon: icon_app_smile,
    titleImg: smile_app_title,
    detail: "Analyzing the patient's facial \ndata and showing the face \nafter treatment.",
    progressFlag: null,
    tranlationCode: 'APP_DETAIL_SMILEAPP',
  },
  {
    isStore: true,
    name: 'BaseApp',
    appName: 'BaseApp',
    icon: '',

    code: 'APP_BASEAPP',
    class: 'base_app',
    color: '#09CC78',
    buttonColor: '#09CC78',
    storeIcon: '',
    titleImg: base_app_title,
    detail: 'Create a flat base of the 3D \nscan data for the 3D pinting \nmodel.',
    progressFlag: null,
    tranlationCode: 'APP_DETAIL_BASEAPP',
  },
  {
    isStore: true,
    name: 'CAD',
    appName: 'exocad',
    icon: icon_app_exe_exocad,

    code: 'APP_EXOCAD',
    class: 'exocad',
    color: '#412C7F',
    buttonColor: '#A089E3',
    storeIcon: icon_app_exocad,
    titleImg: exocad_title,
    detail: 'CAD program to design \ndental prosthesis with \n3D data.',
    progressFlag: 3,
    tranlationCode: 'APP_DETAIL_EXOCAD',
  },
  {
    isStore: false,
    name: 'hyperDENT',
    appName: 'Hyperdent',
    icon: icon_app_exe_cam,
    code: 'APP_HYPERDENT',
    class: 'hyperdent',
    color: '',
    buttonColor: '',
    storeIcon: '',
    titleImg: '',
    detail: '',
    progressFlag: 5,
    tranlationCode: '',
  },
  {
    isStore: true,
    name: 'MotionApp',
    appName: 'MotionApp',
    icon: icon_app_milling,

    code: 'APP_MOTIONAPP',
    class: 'motion_app',
    color: '#17288A',
    buttonColor: '#7989E1',
    storeIcon: icon_app_milling,
    titleImg: motion_app_title,
    detail: 'Control and monitor CRAFT \n5X milling dental prostheses.',
    progressFlag: null,
    tranlationCode: 'APP_DETAIL_MOTIONAPP',
  },
];

export const machineSettingList22 = [
  {
    img: freedom_i_horizontal,
    code: 'SCAN_IOS',
    textCode: 'MACHINE_SCAN_IOS',
    recovery: 'SCAN_IOS_RECOVERY',
    backup: 'SCAN_IOS_BACKUP',
  },
  {
    img: freedom_i_horizontal,
    code: 'SCAN_IOS',
    textCode: 'MACHINE_SCAN_IOS',
    recovery: 'SCAN_IOS_RECOVERY',
    backup: 'SCAN_IOS_BACKUP',
  },
  {
    img: freedom_i_horizontal,
    code: 'SCAN_IOS',
    textCode: 'MACHINE_SCAN_IOS',
    recovery: 'SCAN_IOS_RECOVERY',
    backup: 'SCAN_IOS_BACKUP',
  },
  {
    img: freedom_i_horizontal,
    code: 'SCAN_IOS',
    textCode: 'MACHINE_SCAN_IOS',
    recovery: 'SCAN_IOS_RECOVERY',
    backup: 'SCAN_IOS_BACKUP',
  },
  {
    img: freedom_i_horizontal,
    code: 'SCAN_IOS',
    textCode: 'MACHINE_SCAN_IOS',
    recovery: 'SCAN_IOS_RECOVERY',
    backup: 'SCAN_IOS_BACKUP',
  },
];

export const directoryTypeList = [{ type: 'WORKSPACE' }, { type: 'SCAN_WORKSPACE' }];

export const scanFileExtionsion = ['.ply', '.stl', '.obj', '.dcm'];
export const reworkTypsList = [
  { type: 'scan', reworkTypeName: 'Scan', reworkTypeIdx: 1, reworkTypeCode: 'REWORK_TYPE_1' },
  { type: 'cam', reworkTypeName: 'Designing', reworkTypeIdx: 2, reworkTypeCode: 'REWORK_TYPE_2' },
  {
    type: 'milling',
    reworkTypeName: 'Milling',
    reworkTypeIdx: 3,
    reworkTypeCode: 'REWORK_TYPE_3',
  },
  {
    type: 'postprocess',
    reworkTypeName: 'Post Process',
    reworkTypeIdx: 4,
    reworkTypeCode: 'REWORK_TYPE_4',
  },
];

export const machineList = [
  /* 
    groupAlias: 'MILLINGMC', // 대분류
    modelGroupAlias: 'CRAFT5X', // 중분류
    image: milling_machine,  // 해당 이미지
  */
  {
    groupAlias: 'MILLINGMC',
    modelGroupAlias: 'CRAFT5X',
    image: product_craftx_5x,
  },
];

export const notificationsIconList = [
  { types: ['PROJECT_CHAT'], src: icon_project_chat },
  { types: ['PROJECT_UPDATE'], src: icon_project_update },
  { types: ['PROJECT_SYNC_REQ'], src: icon_project_invite },
  { types: ['PROJECT_ACCEPT'], src: icon_project_accept },
  // TEMP: PROJECT_REJECT
  { types: ['NEW_PARTNER_REQ', 'PARTNER_ACCEPT', 'PROJECT_REJECT'], src: icon_partner_send },
  { types: ['PROJECT_MANAGER'], src: icon_project_manager },
];

export const languageFilters = [
  {
    code: 'ko',
    filters: ['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'],
  },
  {
    code: 'en',
    filters: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
  },
  {
    code: 'ja',
    filters: ['あ', 'か', 'さ', 'た', 'な', 'は', 'ま', 'や', 'ら', 'わ'],
  },
];

export const languageList = [
  {
    id: 0,
    code: 'ko',
    text: '한국어',
    all: '전체',
    transCode: 'en',
    transText: 'a-z',
    transDefaultText: 'ㄱ-ㅎ',
  },
  {
    id: 1,
    code: 'en',
    text: 'English',
    all: 'ALL',
    transCode: null,
    transText: null,
    transDefaultText: null,
  },
  {
    id: 2,
    code: 'ja',
    text: '日本語',
    all: '全体',
    transCode: 'en',
    transText: 'a-z',
    transDefaultText: 'あ-わ',
  },
];

export const maxillaList = [11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28];
export const mandibleList = [31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48];

export const companyType = {
  clinic: {
    id: 1,
    label: 'Clinic',
    index: 'clinic',
  },
  lab: {
    id: 2,
    label: 'CAD Lab',
    index: 'lab',
  },
  milling: {
    id: 3,
    label: 'Milling Center',
    index: 'milling',
  },
  designer: {
    id: 4,
    label: 'Designer',
    index: 'designer',
  },
};

export const genderList = {
  M: 'Male',
  F: 'Female',
  N: 'None',
};

export const indicationOptionList = {
  default: {
    mainOption: [
      {
        key: 'waxupScan',
        title: <T>OPTION_WAXUP_SCAN</T>,
        type: 'radioButton',
      },
      {
        key: 'materialProstheticGingiva',
        title: <T>OPTION_MATERIAL_PROSTHETIC_GINGIVA</T>,
        type: 'dropdown',
      },
      {
        key: 'materialProstheticTooth',
        title: <T>OPTION_MATERIAL_PROSTHETIC_TOOTH</T>,
        type: 'dropdown',
      },
      {
        key: 'materialProstheticMonoblock',
        title: <T>OPTION_MATERIAL_PROSTHETIC_MONOBLOCK</T>,
        type: 'dropdown',
      },
    ],
    checkBox: [
      {
        key: 'situScan',
        title: <T>PROJECT_OPTION_SCAN_PRE_OP</T>,
      },
      {
        key: 'separateGingivaScan',
        title: <T>PROJECT_OPTION_SCAN_GINGIVA</T>,
      },
    ],
    radioButton: [
      {
        key: 'aestheticPlateScan',
        title: <T>OPTION_AESTHETIC_PLATE_SCAN</T>,
      },
      {
        key: 'virtualGingiva',
        title: <T>OPTION_VIRTUAL_GINGIVA</T>,
      },
      {
        key: 'virtualExtractionOrCopyInWizardMode',
        title: <T>OPTION_VIRTUAL_EXTRACTION_OR_COPY_IN_WIZARD_MODE</T>,
      },
      {
        key: 'thimbleCrown',
        title: <T>OPTION_THIMBLE_CROWN</T>,
      },
      {
        key: 'cervicalAdaption',
        title: <T>OPTION_CERVICAL_ADAPTION</T>,
      },
      {
        key: 'biteSplintToothMode',
        title: <T>OPTION_BITE_SPLINT_TOOTH_MODE</T>,
      },
      {
        key: 'prostheticToothScalingMode',
        title: <T>OPTION_PROSTHETIC_TOOTH_SCALING_MODE</T>,
        type: 'dropdown',
      },
    ],
    slider: [
      {
        key: 'gapWidthCement',
        title: <T>OPTION_GAP_WIDTH_CEMENT</T>,
      },
      {
        key: 'minimalTickness',
        title: <T>OPTION_MINIMAL_TICKNESS</T>,
      },
      {
        key: 'shrinking',
        title: <T>OPTION_SHRINKING</T>,
      },
      {
        key: 'shrinkingBottom',
        title: <T>OPTION_SHRINKING_BOTTOM</T>,
      },
      {
        key: 'overpressAdditionalSpacing',
        title: <T>OPTION_OVERPRESS_ADDITIONAL_SPACING</T>,
      },
      {
        key: 'provisionalCrownShoulderSlope',
        title: <T>OPTION_PROVISIONAL_CROWN_SHOULDER_SLOPE</T>,
      },
      {
        key: 'provisionalCrownShoulderWidth',
        title: <T>OPTION_PROVISIONAL_CROWN_SHOULDER_WIDTH</T>,
      },
      {
        key: 'provisionalCrownTaperSlope',
        title: <T>OPTION_PROVISIONAL_CROWN_TAPER_SLOPE</T>,
      },
      {
        key: 'inlayThicknessRunOutDistance',
        title: <T>OPTION_INLAY_THICKNESS_RUN_OUT_DISTANCE</T>,
      },
      {
        key: 'partialSurveyDraftAngle',
        title: <T>OPTION_PARTIAL_SURVEY_DRAFT_ANGLE</T>,
      },
      {
        key: 'biteSplintBlockOutAngle',
        title: <T>OPTION_BITE_SPLINT_BLOCK_OUT_ANGLE</T>,
      },
      {
        key: 'biteSplintThicknessOcclusal',
        title: <T>OPTION_BITE_SPLINT_THICKNESS_OCCLUSAL</T>,
      },
      {
        key: 'biteSplintThicknessPeripheral',
        title: <T>OPTION_BITE_SPLINT_THICKNESS_PERIPHERAL</T>,
      },
      {
        key: 'virtualGingivaDesignBottomBlockOutOffset',
        title: <T>OPTION_VIRTUAL_GINGIVA_DESIGN_BOTTOM_BLOCK_OUT_OFFSET</T>,
      },
      {
        key: 'offsetSubStructureThickness',
        title: <T>OPTION_OFFSET_SUBSTRUCTURE_THICKNESS</T>,
      },
    ],
  },
  advanced: [
    {
      key: 'cementGapStart',
      type: 'slider',
      title: <T>OPTION_CEMENT_GAP_START</T>,
    },
    {
      key: 'cementGapEnd',
      type: 'slider',
      title: <T>OPTION_CEMENT_GAP_END</T>,
    },
    {
      key: 'crownAdditionalSpacingZ',
      type: 'slider',
      title: <T>OPTION_CROWN_ADDITIONAL_SPACING_Z</T>,
    },
    {
      key: 'crownAdditionalSpacingX',
      type: 'slider',
      title: <T>OPTION_CROWN_ADDITIONAL_SPACING_X</T>,
    },
    {
      key: 'crownAdditionalSpacingZOnTop',
      type: 'slider',
      title: <T>OPTION_CROWN_ADDITIONAL_SPACING_Z_ON_TOP</T>,
    },
    {
      key: 'crownBorderHorizontalSize',
      type: 'slider',
      title: <T>OPTION_CROWN_BORDER_HORIZONTAL_SIZE</T>,
    },
    {
      key: 'crownBorderAngledSize',
      type: 'slider',
      title: <T>OPTION_CROWN_BORDER_ANGLED_SIZE</T>,
    },
    {
      key: 'crownBorderAngle',
      type: 'slider',
      title: <T>OPTION_CROWN_BORDER_ANGLE</T>,
    },
    {
      key: 'crownBorderVerticalSize',
      type: 'slider',
      title: <T>OPTION_CROWN_BORDER_VERTICAL_SIZE</T>,
    },
    {
      key: 'connectorArea',
      type: 'slider',
      title: <T>OPTION_CONNECTOR_AREA</T>,
    },
    {
      key: 'overpressMinThickness',
      type: 'slider',
      title: <T>OPTION_OVERPRESS_MIN_THICKNESS</T>,
    },
    {
      key: 'untouchableZoneNearPreparationMargin',
      type: 'slider',
      title: <T>OPTION_UNTOUCHABLE_ZONE_NEAR_PREPARATION_MARGIN</T>,
    },
    {
      key: 'minThicknessNearPreparationMargin',
      type: 'slider',
      title: <T>OPTION_MIN_THICKNESS_NEAR_PREPARATION_MARGIN</T>,
    },
    {
      key: 'minThicknessFullDistanceToPreparationMargin',
      type: 'slider',
      title: <T>OPTION_MIN_THICKNESS_FULL_DISTANCE_TO_PREPARATION_MARGIN</T>,
    },
    {
      key: 'minThicknessGingivaDesign',
      type: 'slider',
      title: <T>OPTION_MIN_THICKNESS_GINGIVA_DESIGN</T>,
    },
    {
      key: 'distanceToGingiva',
      type: 'slider',
      title: <T>OPTION_DISTANCE_TO_GINGIVA</T>,
    },
    {
      key: 'distanceToAntagonist',
      type: 'slider',
      title: <T>OPTION_DISTANCE_TO_ANTAGONIST</T>,
    },
    {
      key: 'distanceToNeighbor',
      type: 'slider',
      title: <T>OPTION_DISTANCE_TO_NEIGHBOR</T>,
    },
    {
      key: 'connectorLingualOfContactAnterior',
      type: 'slider',
      title: <T>OPTION_CONNECTOR_LINGUAL_OF_CONTACT_ANTERIOR</T>,
    },
    {
      key: 'prostheticMonoblockMode',
      type: 'radio',
      title: <T>OPTION_PROSTHETIC_MONOBLOCK_MODE</T>,
    },
    {
      key: 'prostheticBaseToothPocketOffset',
      type: 'slider',
      title: <T>OPTION_PROSTHETIC_BASE_TOOTH_POCKET_OFFSET</T>,
    },
    {
      key: 'prostheticBaseMinThickness',
      type: 'slider',
      title: <T>OPTION_PROSTHETIC_BASE_MIN_THICKNESS</T>,
    },
    {
      key: 'prostheticBaseThickness',
      type: 'slider',
      title: <T>OPTION_PROSTHETIC_BASE_THICKNESS</T>,
    },
    {
      key: 'prostheticBaseCervicalThickness',
      type: 'slider',
      title: <T>OPTION_PROSTHETIC_BASE_CERVICAL_THICKNESS</T>,
    },
    {
      key: 'connectorShapeType',
      type: 'radio',
      title: <T>OPTION_CONNECTOR_SHAPE_TYPE</T>,
    },
    {
      key: 'connectorUseWidthAndHeightInsteadOfArea',
      type: 'radio',
      title: <T>OPTION_CONNECTOR_USE_WIDTH_AND_HEIGHT_INSTEAD_OF_AREA</T>,
    },
    {
      key: 'connectorPullDownToVirtualGingiva',
      type: 'slider',
      title: <T>OPTION_CONNECTOR_PULL_DOWN_TO_VIRTUAL_GINGIVA</T>,
    },
    {
      key: 'connectorWidth',
      type: 'slider',
      title: <T>OPTION_CONNECTOR_WIDTH</T>,
    },
    {
      key: 'connectorHeight',
      type: 'slider',
      title: <T>OPTION_CONNECTOR_HEIGHT</T>,
    },
    {
      key: 'partialMCStipplePattern',
      type: 'radio',
      title: <T>OPTION_PARTIAL_MC_STIPPLE_PATTERN</T>,
    },
    {
      key: 'partialMeshProfile',
      type: 'radio',
      title: <T>OPTION_PARTIAL_MESH_PROFILE</T>,
    },
    {
      key: 'partialCloneValue2',
      type: 'slider',
      title: <T>OPTION_PARTIAL_CLONE_VALUE2</T>,
    },
    {
      key: 'partialMCBaseThickness',
      type: 'slider',
      title: <T>OPTION_PARTIAL_MC_BASE_THICKNESS</T>,
    },
    {
      key: 'partialMCStippleThickness',
      type: 'slider',
      title: <T>OPTION_PARTIAL_MC_STIPPLE_THICKNESS</T>,
    },
    {
      key: 'partialMeshHoleSize',
      type: 'slider',
      title: <T>OPTION_PARTIAL_MESH_HOLE_SIZE</T>,
    },
    {
      key: 'partialMeshReliefHeight',
      type: 'slider',
      title: <T>OPTION_PARTIAL_MESH_RELIEF_HEIGHT</T>,
    },
    {
      key: 'partialMeshThickness',
      type: 'slider',
      title: <T>OPTION_PARTIAL_MESH_THICKNESS</T>,
    },
    {
      key: 'partialCloneValue3',
      type: 'slider',
      title: <T>OPTION_PARTIAL_CLONE_VALUE3</T>,
    },
    {
      key: 'partialCloneValue1',
      type: 'slider',
      title: <T>OPTION_PARTIAL_CLONE_VALUE1</T>,
    },
    {
      key: 'prostheticBaseMinThicknessUnderTeeth',
      type: 'slider',
      title: <T>OPTION_PROSTHETIC_BASE_MIN_THICKNESS_UNDER_TEETH</T>,
    },
    {
      key: 'prostheticBaseToothPocketOffsetAnterior',
      type: 'slider',
      title: <T>OPTION_PROSTHETIC_BASE_TOOTH_POCKET_OFFSET_ANTERIOR</T>,
    },
  ],
};

export const teethSortValue = [
  18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,

  38, 37, 36, 35, 34, 33, 32, 31, 41, 42, 43, 44, 45, 46, 47, 48,
];

export const vertexShader = `
  varying vec3 vNormal;
  varying vec2 vUv;
  varying vec3 vColor;
  void main() {
    vNormal = normalize(normalMatrix * normal);
    vUv = uv;
    vColor = color;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const fragmentShader = `
  varying vec3 vNormal;
  varying vec2 vUv;
  varying vec3 vColor;
  uniform vec4 frontColor;
  uniform vec4 innerColor;
  uniform float opacity;
  uniform bool isVertexColor;
  uniform bool isTexture;
  uniform vec3 lightDirections[3];
  uniform float lightIntensities[3];
  uniform sampler2D textureMap; // 'texture'는 예약어이므로 이름 변경
  uniform float roughness; // roughness 유니폼 추가
  uniform float metalness; // metalness 유니폼 추가

  void main() {
    vec3 normal = normalize(vNormal);
    vec3 ambient = vec3(0.2); // 주변광 강도 조절

    // texture 또는 다른 색상 사용
    vec3 color;
    if (isTexture) {
      color = texture(textureMap, vUv).rgb;
    } else if (isVertexColor) {
      color = vColor;
    } else {
      color = frontColor.rgb;
    }

    float totalLightIntensity = 0.0;
    vec3 totalSpecular = vec3(0.0); // 모든 광원에 대한 스펙큘러 계산

    for(int i = 0; i < 3; i++) {
      vec3 light = normalize(lightDirections[i]);
      float diffuse = max(dot(normal, light), 0.0) * lightIntensities[i];
      totalLightIntensity += diffuse;

      vec3 reflectDir = reflect(-light, normal);
      float specWeight = 0.8; // 스펙큘러 하이라이트 가중치를 더 낮춤
      float spec = pow(max(dot(reflectDir, light), 0.0), (1.0 - roughness) * 50.0) * specWeight;
      vec3 specular = mix(vec3(0.04), color, metalness) * spec;
      totalSpecular += specular * lightIntensities[i];
    }

    totalLightIntensity = min(totalLightIntensity, 1.0);
    vec3 finalColor = (color * totalLightIntensity + totalSpecular) + ambient;

    // 완전 투명한 픽셀 제거
    if (opacity <= 0.0) {
      discard;
    }

    if (gl_FrontFacing) {
      gl_FragColor = vec4(finalColor, opacity);
    } else {
      gl_FragColor = vec4((innerColor.rgb * totalLightIntensity) + ambient, innerColor.a * opacity);
    }
  }
`;

export const clinicModelTypes = ['OBJ', 'PLY', 'STL'];
export const clinicImageTypes = ['PNG', 'JPG', 'JPEG', 'GIF'];
export const clinicHtmlTpyes = ['HTML'];

export const customMaterial = {
  vertexShader,
  fragmentShader,
  side: THREE.DoubleSide,
  transparent: true,
  opacity: 1, // opacity 설정
  blending: THREE.NormalBlending, // 기본 블렌딩
  uniforms: {
    innerColor: { value: new THREE.Vector4(0.7, 0.7, 0.7, 1) },
    frontColor: { value: new THREE.Vector4(0.82, 0.71, 0.55, 1) },
    opacity: { value: 1 },
    lightDirections: {
      value: [
        new THREE.Vector3(1, 1, 1),
        new THREE.Vector3(-1, -1, -1),
        new THREE.Vector3(0, 0, 1),
      ],
    },
    lightIntensities: { value: [0.5, 0.5, 0.5] }, // 각 조명의 강도
    roughness: { value: 0.5 }, // roughness 설정
    metalness: { value: 0.1 }, // metalness 설정
  },
  vertexColors: true,
  polygonOffset: true,
  polygonOffsetFactor: 1,
  polygonOffsetUnits: 1,
};
